import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {
  bulkDedicatedImport,
  createDedicatedNumberList,
} from '../DedicatedNumberSlice/DedicatedNumberSlice'
import Select from 'react-select'
import {KTSVG, countries} from '../../../../../_metronic/helpers'
import Dropzone from 'react-dropzone'

import {Formik, Field, ErrorMessage, Form} from 'formik'
import {AdminDedicatedNumber} from '../../../../Utils/_helpers/ValidationSchema'
import {DEDICATED_NUMBER_OPTIONS, NUMBER_TYPE} from '../../../../Utils/Constant/ConstantForWebsite'

const AddNewDedicatedNumber = ({show, handleClose}: any) => {
  const dispatch = useDispatch()
  const [checkbox, setCheckbox] = useState(false)
  const [addNumber, setAddNumber] = useState<any>({
    audNumber: '',
    gateway: '',
    country: 'au',
    type: 'SMS',
  })
  const [errors, setErrors] = useState<any>()
  const [finalData, setFinalData] = useState<any>({
    name: '',
    file: '',
  })

  const paymentGatewayList = useSelector((state: any) => state?.paymentGateway?.GatewayManagement)

  const handleSubmit = (value: any) => {
    console.log(value, '7777777777777')

    if (!checkbox) {
      const data: any = new FormData()
      for (var key in finalData) {
        data.append(key, finalData[key])
      }
      dispatch(bulkDedicatedImport(data))
      handleClose()
      setFinalData({
        name: '',
        file: '',
      })
    } else {
      dispatch(createDedicatedNumberList(value))
    }
    handleClose()
  }

  const validation = (val: any) => {
    const error: any = {}

    if (val?.audNumber == '') {
      error.audNumber = 'please enter Number'
    }
    if (
      !/^\(?(?:\+?61|0)(?:(?:2\)?[ -]?(?:3[ -]?[38]|[46-9][ -]?[0-9]|5[ -]?[0-35-9])|3\)?(?:4[-]?[0-57-9]|[57-9][ -]?[0-9]|6[ -]?[1-67])|7\)?[ -]?(?:[2-4][ -]?[0-9]|5[ -]?[2-7]|7[ -]?6)|8\)?[ -]?(?:5[ -]?[1-4]|6[ -]?[0-8]|[7-9][ -]?[0-9]))(?:[ -]?[0-9]){6}|4\)?[ -]?(?:(?:[01][ -]?[0-9]|2[ -]?[0-57-9]|3[ -]?[1-9]|4[ -]?[7-9]|5[ -]?[018])[ -]?[0-9]|3[ -]?0[ -]?[0-5])(?:[ -]?[0-9]){5})$/.test(
        val?.audNumber
      )
    ) {
      error.audNumber = 'please enter valid number'
    }
    if (val?.gateway == '') {
      error.gateway = 'please select gateway'
    }
    if (val?.country == '') {
      error.country = 'please select gateway'
    }
    setErrors(error)
    return error
  }

  const acceptedFileTypes = {
    'text/csv': ['.csv'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx', '.xls'],
  }
  const handleChange = (e: any) => {
    setFinalData({...finalData, name: e?.[0]?.name, file: e[0]})
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-600px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h1>Add Dedicated Number</h1>
        </div>
        <div className='modal-body p-20 '>
          <div className='row'>
            <div className='fv-row mb-5'>
              <div className='form-check form-check-custom form-check-solid'>
                <input
                  className='form-check-input mb-6'
                  type='radio'
                  value=''
                  id='flexRadioChecked'
                  checked={!checkbox}
                  onChange={() => {
                    setCheckbox(false)
                  }}
                />
                <label
                  className='form-check-label align-items-start flex-column d-flex ms-3'
                  htmlFor='flexRadioChecked'
                >
                  <span className='card-label fw-bolder fs-5'>Import new list</span>
                  <span className='text-muted fs-7'>
                    Upload a new list from a file, Acceptable file Types: Comma Seprated CSV or text
                    files.{' '}
                    <a href='https://api.cellcast.com/demoFiles/sample_dedicated_numbers.csv'>
                      Download example Csv
                    </a>
                  </span>
                  {!checkbox && (
                    <>
                      {finalData?.name !== '' ? (
                        <>
                          <section className='dragAndDrop'>
                            <div className='removeFile'>
                              <span className='fs-10'> {finalData?.name}</span>

                              <KTSVG
                                onClick={() => {
                                  setFinalData({
                                    name: '',
                                    file: '',
                                    mergeLabels: '',
                                    tagIds: '',
                                  })
                                }}
                                path='/media/misc/cross-square.svg'
                                className='svg-icon  reomveIcon'
                              />
                            </div>
                          </section>
                        </>
                      ) : (
                        <Dropzone onDrop={handleChange} accept={acceptedFileTypes}>
                          {({getRootProps, getInputProps}) => (
                            <section className='dragAndDrop'>
                              <KTSVG
                                path={'/media/svg/dragandDrop.svg'}
                                className='svg-icon-3x me-3'
                              />
                              <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <span className='fs-7 d-block fw-boldest'>
                                  Drop files here or click to upload
                                </span>
                                <span className='text-muted fs-7'>csv,xlsx</span>
                              </div>
                            </section>
                          )}
                        </Dropzone>
                      )}
                    </>
                  )}
                </label>
              </div>
            </div>
            <div className='form-check form-check-custom form-check-solid'>
              <input
                className='form-check-input mb-6'
                type='radio'
                value=''
                id='flexRadioChecked2'
                checked={checkbox}
                onChange={() => setCheckbox(true)}
              />
              <label
                className='form-check-label align-items-start flex-column d-flex ms-3'
                htmlFor='flexRadioChecked2'
              >
                <span className='card-label fw-bolder fs-5'>Add one number</span>
                <span className='text-muted fs-7'>Type the number you'd like to add</span>
              </label>
            </div>
            {checkbox && (
              <div className='fv-row mb-5'>
                <Formik
                  initialValues={addNumber}
                  validationSchema={AdminDedicatedNumber}
                  onSubmit={handleSubmit}
                >
                  {({isSubmitting, values, setFieldValue}: any) => (
                    <Form>
                      <div>
                        <label
                          className=' col-form-label required fw-bold fs-6'
                          htmlFor='audNumber'
                        >
                          Gateway Number
                        </label>
                        <Field
                          className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                          type='text'
                          id='audNumber'
                          name='audNumber'
                          placeholder='Gateway Number'
                        />
                        <ErrorMessage className='text-danger' name='audNumber' component='div' />
                      </div>

                      <div>
                        <label className=' col-form-label required fw-bold fs-6' htmlFor='gateway'>
                          Gateway
                        </label>
                        <Select
                          value={{
                            value:
                              paymentGatewayList?.find((key: any) => key?._id === values?.gateway)
                                ?._id || '',
                            label: `${
                              paymentGatewayList?.find((key: any) => key?._id === values?.gateway)
                                ?.DB || 'Select'
                            }-${
                              paymentGatewayList?.find((key: any) => key?._id === values?.gateway)
                                ?.gatewayName || 'Gateway'
                            }`,
                          }}
                          onChange={(e: any) => {
                            setFieldValue('gateway', e.value)
                            const gatewayData = paymentGatewayList?.find((key: any) => key?._id === e.value)
                            const gatewayName = gatewayData?.gatewayName
                            const gatewayConfig = gatewayData?.gatewayConfig

                            const DB = gatewayData?.DB
                            if (DB?.includes( NUMBER_TYPE.MMS)) {
                              setFieldValue('type', NUMBER_TYPE.MMS)
                            } else if(DB.includes(NUMBER_TYPE.VOICE)) {
                              setFieldValue('type', NUMBER_TYPE.VOICE)
                            } else {
                              setFieldValue('type', NUMBER_TYPE.SMS)
                            }
                          }}
                          options={[
                            {value: '', label: 'select'},
                            ...paymentGatewayList?.map((key: any, id: number) => ({
                              value: `${key?._id}`,
                              label: `${key?.DB}-${key?.gatewayName}`,
                            })),
                          ]}
                        />
                        <ErrorMessage className='text-danger' name='gateway' component='div' />
                      </div>

                      <div>
                        <label className=' col-form-label required fw-bold fs-6' htmlFor='country'>
                          Country
                        </label>
                        <Select
                          value={{
                            value: countries?.find((key: any) => key?.value === values?.country)
                              ?.value,
                            label: countries?.find((key: any) => key?.value === values?.country)
                              ?.label,
                          }}
                          onChange={(e: any) => setFieldValue('country', e?.value)}
                          options={countries}
                        />
                        <ErrorMessage className='text-danger' name='country' component='div' />
                      </div>

                      <div>
                        <label className=' col-form-label required fw-bold fs-6' htmlFor='type'>
                          Type
                        </label>
                        <Select
                          value={{value: values?.type, label: values?.type === NUMBER_TYPE.MMS ? `${NUMBER_TYPE.SMS} + ${NUMBER_TYPE.MMS}` : values?.type}}
                          onChange={(e: any) => setFieldValue('type', e?.value)}
                          options={DEDICATED_NUMBER_OPTIONS}
                        />
                        <ErrorMessage className='text-danger' name='type' component='div' />
                      </div>

                      <div className='d-flex flex-center mt-5'>
                        <div id='kt_drawer_chat_close'>
                          <button
                            type='button'
                            onClick={() => {
                              handleClose()
                              setAddNumber({
                                audNumber: '',
                                gateway: '',
                                country: 'au',
                                type: NUMBER_TYPE.SMS,
                              })
                            }}
                            className='btn btn-md gray_bg_purple me-2'
                          >
                            Cancel
                          </button>
                        </div>
                        <button type='submit' className='btn btn-primary'>
                          Submit
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            )}

            {!checkbox && (
              <div className='d-flex flex-center mt-5'>
                <button onClick={handleSubmit} type='submit' className='btn btn-primary w-100px'>
                  Submit
                </button>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AddNewDedicatedNumber
